<template>
  <span
    :class="{
            'text-red': this.value < 0,
            'text-green': this.value > 0,
        }"
  >{{this.formated}}</span>
</template>

<script>
export default {
  props: {
    value: [String, Number, Boolean],
    formated: [String, Number],
  },
};
</script>